import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { BasePageComponent } from '../../../base-page.component';
import { Machine } from '../../../shared/models/machine.model';
import { MachineModuleService } from '../../../shared/services/machineModule.service';

@Component({
  templateUrl: './machine-detail-page.component.html',
  standalone: false
})
export class MachineDetailPageComponent extends BasePageComponent implements OnInit {
  machine: Machine;

  constructor(private router: Router, location: Location, private route: ActivatedRoute, private machinesService: MachineModuleService) {
    super(location);
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const machineSerial = params['machineSerial'];
      this.machinesService.getMachine(machineSerial).subscribe((machine) => {
        this.machine = machine;
      });
    });
  }

  editMachine() {
    this.router.navigate([this.appRoute, 'machines', this.machine.serialNumber, 'edit']);
  }

  createInspection(): void {
    this.router.navigate([
      this.inspectionsRoute,
      'selectMachine',
      this.machine.productLine,
      this.machine.modelId,
      this.machine.serialNumber
    ]);
  }

  viewInspections() {
    this.router.navigate([`${this.appRoute}/machines/${this.machine.serialNumber}/inspections`]);
  }

  public goToBack() {
    this.router.navigate([this.appRoute, 'customers', this.machine.clientNumber, 'machines']);
  }
}
